define('evicommon/search/visual.search.helper',['require','exports','module','underscore','backbone','../spf/spf.helper'],function(require, exports, module){
  var _         = require('underscore');
  var Backbone  = require('backbone');
  var SPFHelper = require('../spf/spf.helper');

  var YES_VALUE = { text: 'Yes', value: 'true' };
  var NO_VALUE = { text: 'No', value: 'false' };

  function VisualSearchHelper(input, fields, filters) {
    this.input = input;
    this.fields = fields;
    this.filters = filters;
    this.fieldBindings({ text: 'displayName' });
    this.bind();
  };

  VisualSearchHelper.extend = Backbone.Model.extend;

  _.extend(VisualSearchHelper.prototype, Backbone.Events, {

    replyValuesCollection: function(fn, context) {
      this.valuesCollection = _.bind(fn, context || this);
      return this;
    },

    valuesCollection: function(value, field) {
      throw new Error('You must overried this function with "valuesCollection" or call "replyValuesCollection"');
    },

    fieldBindings: function(bindings) {
      this._fieldResultsBindings = _.extend({}, bindings);
      return this;
    },

    valueBindings: function(bindings) {
      this._valueResultsBindings = _.extend({}, bindings);
      return this;
    },

    setDefaultFieldDisplay: function(text) {
      this.input.fieldResultsView.default = text;
      return this;
    },

    isFieldBoolean: function(field) {
      return !!field.get('boolean') || !!field.get('bool');
    },

    resetInputCollection: function() {
      var self = this;

      var filters = this.filters.filter(function(model) {
        return !model.get('hidden');
      });

      var tokens = _.map(filters, function(filter) {
        var value = filter.get('value'),
            field = filter.get('field');

        if (self.isFieldBoolean(field)) {
          value = value == YES_VALUE.value ? YES_VALUE.text : NO_VALUE.text;
        }

        return {
          text: field.get('displayName'),
          value: value
        };
      });
      this.input.collection.set(tokens);
      return this;
    },

    bind: function() {
      var vs   = this.input,
          self = this;

      this.reset();

      this
          .listenTo(this.filters, 'add remove change reset', _.debounce(function() {
            this.resetInputCollection()
            this.trigger('filters:change');
          }))
          .listenTo(vs, 'search:results:text', this.onSearchField)
          .listenTo(vs, 'search:results:value', this.onSearchValue)
          .listenTo(vs, 'search:press:footer', this.onSearchFooterPress)
          .listenTo(vs, 'token:remove token:add token:revised', this.onTokensChange)

      _.defer(function() {
        self.resetInputCollection();
      });

      return this;
    },

    reset: function() {
      this.stopListening()
      this.off();
      if (this.input) {
        this.input.collection.reset();
      }
      return this;
    },

    createFieldsCollection: function(searchText) {
      var self = this;

      var filteredFields = _.chain(this.fields.toArray())
          .filter(function(field) {
            return self.fieldFilter(searchText, field);
          })
          .sortBy(function() {
            return self.fieldSort.apply(self, arguments);
          })
          .value();

      return new Backbone.Collection(filteredFields);
    },

    fieldFilter: function(searchText, field) {
      return field.get('displayName').toLowerCase().indexOf(String(searchText).toLowerCase()) != -1;
    },

    fieldSort: function(field) {
      return field.get('displayName');
    },

    nextValuesPage: function() {
      this.valuesSpfHelper.incrementPage();
      return this;
    },

    valuesPageSize: function() {
      if (this.valuesSpfHelper) {
        return this.valuesSpfHelper.pageSize();
      }
      return 0;
    },

    valuesTotalItems: function() {
      if (this.valuesSpfHelper) {
        return this.valuesSpfHelper.totalItems();
      }
      return 0;
    },

    onSearchField: function(text) {
      var collection = this.createFieldsCollection(text);
      this.setFieldResultsCollection(collection);
    },

    onSearchValue: function(value, text) {
      var field = this.fields.findWhere({ displayName: text })
      if (!field) { return; }
      var collection;

      // add special handling for boolean values
      if (this.isFieldBoolean(field)) {
        var loweredValue = String(value).toLowerCase().trim();
        var values = _
            .chain([
              YES_VALUE,
              NO_VALUE
            ])
            .filter(function(v) {
              return String(v.text).toLowerCase().indexOf(loweredValue) >= 0;
            })
            .value()
            ;
        collection = new Backbone.Collection(values);
        this.valueBindings({ text: 'text' });
      } else {
        collection = this.valuesCollection(value, field, this);
      }

      if (collection && !collection.spfHelper && collection.addAdapter) {
        new SPFHelper(collection, { autoFetch: true });
      }

      this.valuesSpfHelper = collection ? collection.spfHelper : null;
      this.setTokenResultsCollection(collection || null);
      this.listenForFooterSync();
    },

    onSearchFooterPress: function() {
      this.nextPage();
      this.listenForFooterSync();
    },

    onTokensChange: function() {
      this.syncTokens();
    },

    setTokenResultsCollection: function(collection) {
      this.input.resultsView.childBindings = this._valueResultsBindings;
      this.input.resultsView.collection = collection;
      return this;
    },

    setFieldResultsCollection: function(collection) {
      this.input.resultsView.childBindings = this._fieldResultsBindings;
      this.input.resultsView.collection = collection;
      return this;
    },

    listenForFooterSync: function() {
      this.listenToOnce(this.input.tokenResultsView, 'render:collection add:child', _.debounce(this.syncFooter));
    },

    syncFooter: function() {
      var itemsCount     = this.valuesPageSize(),
          totalItems     = this.valuesTotalItems(),
          remainingCount = totalItems - itemsCount;

      if (!remainingCount || !itemsCount) {
        //  vs.tokenResultsView.hideFooter();
       } else {
        //  vs.tokenResultsView.showFooter({ count: itemsCount + ' of ' + totalItems, text: 'View More' });
       }
    },

    syncTokens: function() {
      var fields  = this.fields,
          filters = [],
          tokens = this.input.collection;

      for (var i = 0, len = tokens.length, token, field, value; i < len; ++i) {
        token = tokens.at(i);
        field = fields.findWhere({ displayName: token.get('text') });
        if (!field) { continue; }
        value =  token.get('value');
        if (this.isFieldBoolean(field)) {
          value = value == YES_VALUE.text ? YES_VALUE.value : NO_VALUE.value
        }
        filters.push({
          field: field,
          value: value
        });
      }
      var hiddenFilters = this.filters.where({ hidden: true });
      this.filters.set(hiddenFilters.concat(filters));
      this.trigger('filters:sync', this.filters);
      return this;
    }

  });

  module.exports = VisualSearchHelper;
})
;
